import { render, staticRenderFns } from "./EsSvga.vue?vue&type=template&id=470b5f29&scoped=true"
import script from "./EsSvga.vue?vue&type=script&lang=js"
export * from "./EsSvga.vue?vue&type=script&lang=js"
import style0 from "./EsSvga.vue?vue&type=style&index=0&id=470b5f29&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470b5f29",
  null
  
)

export default component.exports